import { all, takeLatest, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../settings/index';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';

const api = new Api('companies');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;
    let { district = [], legal_entity = [] } = payload;

    if (!Array.isArray(district)) {
      district = [district];
    }

    if (!Array.isArray(legal_entity)) {
      legal_entity = [legal_entity];
    }

    const result = yield call(
      sendRequest,
      api.load,
      {
        search: {
          page,
          pageSize,
          column,
          order,
          filter,
          district,
          legal_entity,
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      const { data, totalCount, filteredCount, sortable_columns, filters } = result.data;

      yield put(
        actions.loadDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
          filters,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData };
export default function* rootSaga() {
  yield all([takeLatest(actions.LOAD, loadData)]);
}
